module.exports = __webpack_public_path__ + "static/img/noticeHD.cff98e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/noticeHD.png
// module id = AWz9
// module chunks = 1